(function () {
  function initContactTabs(root) {
    if (!root || root.dataset.tabsReady === 'true') return;
    root.dataset.tabsReady = 'true';

    var tabs = Array.prototype.slice.call(
      root.querySelectorAll('.contact-page__sidebar [data-contact-tab]')
    );
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-contact-panel]'));
    var titles = Array.prototype.slice.call(root.querySelectorAll('[data-contact-title]'));
    var inner = root.querySelector('[data-contact-inner]');

    function activate(tabId, pushHash) {
      if (!tabId) return;

      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-contact-tab') === tabId;
        tab.classList.toggle('contact-page__sidebar-link--active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-contact-panel') === tabId;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      titles.forEach(function (title) {
        var active = title.getAttribute('data-contact-title') === tabId;
        title.hidden = !active;
      });

      if (inner) {
        inner.setAttribute('data-active-tab', tabId);
      }

      if (pushHash) {
        var hash = '#' + tabId;
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', hash);
        } else {
          window.location.hash = tabId;
        }
      }
    }

    root.addEventListener('click', function (event) {
      var tabTrigger = event.target.closest('[data-contact-tab]');
      if (tabTrigger && root.contains(tabTrigger)) {
        event.preventDefault();
        activate(tabTrigger.getAttribute('data-contact-tab'), true);
        return;
      }

      var faqTrigger = event.target.closest('[data-faq-trigger]');
      if (!faqTrigger || !root.contains(faqTrigger)) return;

      var item = faqTrigger.closest('[data-faq-item]');
      if (!item) return;

      var open = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', open ? 'false' : 'true');
      faqTrigger.setAttribute('aria-expanded', open ? 'false' : 'true');
    });

    var initial = 'contact';
    var hash = (window.location.hash || '').replace(/^#/, '');
    if (hash && root.querySelector('.contact-page__sidebar [data-contact-tab="' + hash + '"]')) {
      initial = hash;
    }

    activate(initial, false);
  }

  function boot() {
    document.querySelectorAll('[data-contact-tabs]').forEach(initContactTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-contact-tabs]')
      : null;
    if (root) {
      root.dataset.tabsReady = 'false';
      initContactTabs(root);
    }
  });
})();
